import { object, number, InferType } from 'yup';
import i18n from '@components/i18n';

const billingItemFields = {
  priceAmount: number()
    .required(i18n.t('validation:required'))
    .moreThan(0, i18n.t('validation:positive')),
  quantity: number()
    .required(i18n.t('validation:required'))
    .min(1, i18n.t('validation:min', { min: 1 })),
  discountPercentage: number()
    .required(i18n.t('validation:required'))
    .min(0)
    .max(100),
};

export type BillingItemEntry = {
  billingItemId: number;
  benefitLimitId: number;
  itemName: string;
  subBenefit: string;
  priceAmount: number;
  quantity: number;
  discountPercentage: number;
};

export const billingItemEditSchema = object(billingItemFields);

export type BillingItemEditFormValues = InferType<typeof billingItemEditSchema>;
